module.exports = __webpack_public_path__ + "img/菜品.882d0e14.svg";